import { View } from '@lernetz/ts-lib';

/**
 * A helper view that simply renders html into the component node
 */
export class HtmlView extends View<string> {

    constructor() {
        super( { template:'', data:'' } );
    }

    init() {
        this.node.innerHTML = this.data;
    }

    update() {
        this.node.innerHTML = this.data;
    }
}
